import { render } from "./cp_SetByHotCity.vue?vue&type=template&id=2355d472&scoped=true"
import script from "./cp_SetByHotCity.vue?vue&type=script&lang=js"
export * from "./cp_SetByHotCity.vue?vue&type=script&lang=js"

import "./cp_SetByHotCity.vue?vue&type=style&index=0&id=2355d472&scoped=scoped&lang=less"

import exportComponent from "E:\\WorkCode\\HZY2026\\Code\\HZY.Student\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2355d472"]])

export default __exports__